export default __webpack_public_path__ + "static/media/Type G main cover.f5302ca5.png";